import { ExamLoadTransferCtrl } from './exam-load-transfer.controller';

export const ExamLoadStepTransferComponent = {
  controller: ExamLoadTransferCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./exam-load-transfer.html'),
};
